import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type AvailabilitiesErrorContainerProps = {
  message: string;
};

function AvailabilitiesErrorContainer({
  message
}: AvailabilitiesErrorContainerProps) {
  return (
    <Box sx={{ p: '16px' }}>
      <Typography
        sx={theme => ({
          color: theme.palette.soy.dark,
          fontSize: '16px',
          fontWeight: 450,
          textAlign: 'center'
        })}
        data-testid="availabilities-error-container"
      >
        {message}
      </Typography>
    </Box>
  );
}

export default AvailabilitiesErrorContainer;
